import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export const VEHICLE_SNAPSHOT_OPERATION = "snapshot" as const;
export const VEHICLE_SNAPSHOT_API_PATH = "/v1/vehicle/{uuid}/snapshot" as const;
export const VEHICLE_SNAPSHOT_RESOURCE = "vehicle" as const;

export type VehicleSnapshotResponse =
  paths[typeof VEHICLE_SNAPSHOT_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useVehicleSnapshotQuery(uuid: string, options?: { enabled?: boolean }) {
  return useQuery<VehicleSnapshotResponse, AxiosError>({
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    queryKey: [VEHICLE_SNAPSHOT_RESOURCE, uuid, VEHICLE_SNAPSHOT_OPERATION],
    queryFn: async () => {
      const apiPath = VEHICLE_SNAPSHOT_API_PATH.replace("{uuid}", uuid);
      const response = await alphartisApiAxios.get<VehicleSnapshotResponse>(apiPath);

      return response.data;
    },
    retry: (failureCount, error) => error.response?.status !== 404 && failureCount < 2,
  });
}
